import React from 'react';
import { supabase } from '../../supabaseClient';
import { useToast } from '../../contexts/ToastContext';
import { Modal, ModalFooter } from '../ui/modal';

function DeleteProjectModal({ show, handleClose, project, onProjectDeleted }) {
  const addToast = useToast();

  const handleDelete = async () => {
    const { error } = await supabase
      .from('projects')
      .delete()
      .eq('id', project.id);

    if (error) {
      console.error('Error deleting project:', error);
      addToast('Error deleting project: ' + error.message, 'danger');
    } else {
      addToast('Project deleted successfully', 'success');
      onProjectDeleted(project.id);
      handleClose();
    }
  };

  return (
    <Modal isOpen={show} onClose={handleClose} title="Delete Project">
      <div className="space-y-3">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Are you sure you want to delete the project "{project.name}"?
        </p>
        <p className="text-sm text-red-600 dark:text-red-400">
          This action cannot be undone.
        </p>
      </div>
      
      <ModalFooter>
        <button
          type="button"
          onClick={handleClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleDelete}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Delete Project
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteProjectModal;